module.exports = __webpack_public_path__ + "static/media/banner_420x230_2.6bead690.jpg";